import { render } from "./EmailDiffContainer.vue?vue&type=template&id=4e3e5b4a"
import script from "./EmailDiffContainer.vue?vue&type=script&lang=js"
export * from "./EmailDiffContainer.vue?vue&type=script&lang=js"
script.render = render

export default script